import React from "react";
import { Container, Row, Col, UncontrolledCollapse } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Fade from "react-reveal/Fade";

const questions = [
  {
    question: "基本組合包括的服務內容?",
    answer:
      "一個已經與後台連接好的網站，我們會代客設定首批資料於網站內顯示，提供教學文件及上門應用教學，於服務有效期內提供Whatsapp 群組解答疑難。"
  },
  {
    question: "如果遇上網站/應用程式上的問題，會如何處理?",
    answer:
      "根據客戶回報的問題，我們會盡快作出回應，一般技術上問題會即日(一個工作天)內作出處理"
  },
  // {
  //   question: "What do I need to know to customize this template?",
  //   answer:
  //     "Our documentation give you all you need to customize your copy. However you will need some basic web design knowledge (HTML, Javascript and CSS)"
  // },
  {
    question: "可以要求在現有的網站/手機應用上新增新功能?",
    answer:
      "當然可以！歡迎隋時聯絡我們，我們會根據客戶的要求作出調整，另外訂製新功能可能需要額外的時間或成本"
  }
];

const Faqs = () => {
  return (
    <section className="section faqs-dd bg-light edge top-left" style={{paddingBottom: 260}}>
      <div className="shapes-container">
        <div className="absolute icon">
          <Fade top left>
            <FontAwesomeIcon icon={["fas", "question"]} />
          </Fade>
        </div>
      </div>

      <Container>
        <div className="section-heading text-center">
          <h2 className="heading-line">常見問題</h2>
          <p className="lead">想知道更多相關的服務內容?</p>
        </div>

        <Row>
          <Col lg="8" className="mx-lg-auto">
            {questions.map((faq, i) => (
              <Fade bottom key={i}>
                <div className="card shadow-box shadow-hover mb-3" key={i}>
                  <div className="card-header py-3">
                    <Link
                      to="#"
                      className="card-title collapsed"
                      id={`toggler-${i}`}
                    >
                      {faq.question}
                    </Link>
                  </div>

                  <UncontrolledCollapse toggler={`#toggler-${i}`}>
                    <div className="card-body">{faq.answer}</div>
                  </UncontrolledCollapse>
                </div>
              </Fade>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Faqs;
